import React, { createContext, useContext, useMemo } from 'react';
import { DEFAULT_ICON_SETTINGS, normalizeIconSettings } from './icon-sizes';

const IconSettingsContext = createContext(DEFAULT_ICON_SETTINGS);

// Installation settings can be supplied here by the future super-admin configuration.
export function IconSettingsProvider({ config, children }) {
  const settings = useMemo(() => normalizeIconSettings(config), [config]);
  return <IconSettingsContext.Provider value={settings}>{children}</IconSettingsContext.Provider>;
}
export function useIconSettings() {
  return useContext(IconSettingsContext);
}
